/* global axios */

import ApiClient from './ApiClient';

class CommentAutomationsAPI extends ApiClient {
  constructor() {
    super('comment_automations', { accountScoped: true });
  }

  toggleActive(id) {
    return axios.post(`${this.url}/${id}/toggle_active`);
  }

  getExecutions(id, { page = 1, perPage = 25 } = {}) {
    return axios.get(`${this.url}/${id}/executions`, {
      params: { page, per_page: perPage },
    });
  }

  fetchInboxPosts(inboxId, { limit = 25, after = null, platform = null } = {}) {
    return axios.get(`${this.baseUrl()}/inboxes/${inboxId}/posts`, {
      params: { limit, after, platform },
    });
  }

  sync(id = null, inboxId = null) {
    if (id) {
      return axios.post(`${this.url}/${id}/sync`);
    }
    return axios.post(`${this.url}/sync`, { inbox_id: inboxId });
  }
}

export default new CommentAutomationsAPI();
